import { render, staticRenderFns } from "./LotItemsEditor.vue?vue&type=template&id=2844cbe6&scoped=true"
import script from "./LotItemsEditor.vue?vue&type=script&lang=js"
export * from "./LotItemsEditor.vue?vue&type=script&lang=js"
import style0 from "./LotItemsEditor.vue?vue&type=style&index=0&id=2844cbe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2844cbe6",
  null
  
)

export default component.exports